import { ICommodity } from 'app/shared/model/commodity.model';

export interface ICommodityLog {
  id?: number;
  commodityPrice?: number;
  commodity?: ICommodity;
}

export const defaultValue: Readonly<ICommodityLog> = {};
